import { render } from "./additionalEquipment.vue?vue&type=template&id=74a13652&scoped=true"
import script from "./additionalEquipment.vue?vue&type=script&lang=js"
export * from "./additionalEquipment.vue?vue&type=script&lang=js"

import "./additionalEquipment.vue?vue&type=style&index=0&id=74a13652&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a13652"]])

export default __exports__